import { RawDraftContentState } from 'draft-js'

const newBlockKey = () => Math.random().toString(36).slice(2, 7)

/** An empty Draft.js document: one empty paragraph, as the editor creates. */
export const createEmptyRichText = (): RawDraftContentState => ({
  blocks: [
    {
      key: newBlockKey(),
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {}
    }
  ],
  entityMap: {}
})

export const isRichTextEmpty = (content: RawDraftContentState | undefined) =>
  !content?.blocks?.some(block => block.text.trim() || block.type === 'atomic')
